export const SITE_LOCALES = {
	'pt-BR': {
		language: 'pt-BR',
		hostname: 'www.eltonethais.com',
		hostnames: ['www.eltonethais.com', 'eltonethais.com'],
		url: 'https://www.eltonethais.com/',
	},
	en: {
		language: 'en',
		hostname: 'www.eltonandthais.com',
		hostnames: ['www.eltonandthais.com', 'eltonandthais.com'],
		url: 'https://www.eltonandthais.com/',
	},
}

export const getLocaleFromHostname = (hostname) => {
	const locale = Object.values(SITE_LOCALES).find((siteLocale) =>
		siteLocale.hostnames.includes(hostname),
	)
	return locale ? locale.language : 'pt-BR'
}

export const isCanonicalSiteHost = (hostname) =>
	Object.values(SITE_LOCALES).some((locale) =>
		locale.hostnames.includes(hostname),
	)

export const getLocaleUrl = (language, hash = '') =>
	`${SITE_LOCALES[language].url}${hash}`
